<!-- src/components/layouts/About.vue -->
<template>
    <div class="about-container">
        <a-card class="image-card" hoverable>
            <a-image
                :src="src"
                alt="MingChen-Panel Logo"
                fit="cover"
                class="favicon-image"
            />
        </a-card>

        <a-card class="info-card" hoverable>
            <h2 class="title">MingChen-Panel</h2>
            <p class="version">v{{ version }}</p>
            <a-descriptions
                :column="1"
                class="descriptions"
                bordered
            >
                <a-descriptions-item label="网站">
                    <a href="https://MingChen-Panel.Top" target="_blank">MingChen-Panel.Top</a>
                </a-descriptions-item>
                <a-descriptions-item label="作者">
                    明晨
                </a-descriptions-item>
            </a-descriptions>
            <div class="footer-content">© 2025 Navigation App</div>
        </a-card>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import favicon from '../../../public/favicon.png';

export default defineComponent({
    name: "About",
    setup() {
        const src = ref(favicon);
        const version = ref('1.1');

        return {
            src,
            version,
        };
    }
});
</script>

<style scoped>
.about-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.image-card {
    width: 150px;
    margin-bottom: 20px;
}

.favicon-image {
    width: 100%;
    height: auto;
}

.info-card {
    width: 100%;
    max-width: 600px;
}

.title {
    text-align: center;
    font-size: 2em;
    margin-bottom: 10px;
}

.version {
    text-align: center;
    color: #888;
    margin-bottom: 20px;
}

.descriptions {
    margin-bottom: 20px;
}

.footer-content {
    text-align: center;
    color: #888;
    margin-top: 20px;
}
</style>
